<template>
  <div class="container main-content">
    <div class="article-content">
      <template v-for="(content, i) in contentSolution">
        <div :key="`content-${i}`" v-html="openLinksInNewTab(content)"></div>
      </template>
    </div>
  </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"

export default {
  name: "SolutionMain",
  watch: {
    '$route.params.id'() {
      this.$store.dispatch('cleanSolution')
      this.$store.dispatch('getSolution', this.$route.params.id)
    }
  },
  computed: {
    solution() {
      return this.$store.getters.solution
    },
    contentSolution() {
      return this.$store.getters.solutionContent
    },
  },
  methods: {
    openLinksInNewTab: openLinksInNewTab,
  },
}
</script>
